import React from 'react';
import { FormRequestCall } from 'components/forms/form-request-call/form-request-call';

import './request-call-modal.scss';

export const DATE_FORMAT = 'DD/MM/YYYY';

const RequestCallModalUI = () => (
  <div className="position-absolute request-call rounded">
    <FormRequestCall
      coreProps={{
        boxDateFormat: DATE_FORMAT,
      }}
      boxDateFormat={DATE_FORMAT}
    />
  </div>
);

export const RequestCallModal = RequestCallModalUI;
